import oAxiosInstance from "config/Axios";

export const apiCallGetAllCotizaciones = () => {
  return oAxiosInstance.get("cotizaciones");
};

export const apiCallGetCotizacion = (nMonId, sFecha) => {
  return oAxiosInstance.get(`cotizaciones/consultar/${nMonId}/${sFecha}`);
};

export const apiCallCotizacionesSave = oData => {
  return oAxiosInstance.post("cotizaciones/agregar", oData);
};

export const apiCallCotizacionesUpdate = oData => {
  return oAxiosInstance.put("cotizaciones/actualizar", oData);
};

export const apiCallCotizacionesDelete = (nMonId, sFecha) => {
  return oAxiosInstance.delete(`cotizaciones/eliminar/${nMonId}/${sFecha}`);
};
